/**
 * Kompakter App-Footer für lex.ivoliq (Styleguide /app/design_guidelines_lex.json).
 * Ersetzt den ivoliq-Marketing-Footer für lex-Anwälte — nur Wortmarke + Rechtliches.
 */
import { Link } from "react-router-dom";

export const LexAppFooter = () => (
  <footer className="border-t mt-auto" style={{ background: "#0A1128", borderColor: "rgba(197,160,89,0.25)" }} data-testid="lex-app-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="flex flex-col items-center sm:items-start gap-0.5">
        <span className="lex-serif text-lg font-semibold text-white">lex<span style={{ color: "#C5A059" }}>.</span>ivoliq</span>
        <span className="text-[11px] text-slate-500" data-testid="lex-brand-bridge">
          ein Produkt von <span className="font-bold text-slate-300">ivoliq<span style={{ color: "#34d399" }}>.</span></span>
        </span>
      </div>
      <p className="lex-mono text-xs text-slate-500 text-center">
        © {new Date().getFullYear()} ivoliq GmbH · FN 680579 b{" "}
        · <Link to="/lex-impressum" className="underline hover:text-slate-300">Impressum</Link>{" "}
        · <Link to="/lex-datenschutz" className="underline hover:text-slate-300">Datenschutz</Link>{" "}
        · <Link to="/lex-agb" className="underline hover:text-slate-300">AGB</Link>{" "}
        · <Link to="/avv" className="underline hover:text-slate-300">AVV</Link>
      </p>
    </div>
  </footer>
);
